<template>
  <layout title="Liveness Detection Demo">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 max-w-7xl w-full md:flex items-start">
        <div class="flex-1 md:ml-8 ml-0">
          <div
            class="font-black text-3xl text-gray-800 inline-block lg:col-span-2 col-span-1 md:mt-0 mt-4"
          >
            Liveness Detection demo
          </div>
          <alertBox>
            We do not store any uploaded images in our databases.<br />
            In this demo will be used your API key.
          </alertBox>
          <div
            class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative"
          >
            <div class="p-4 text-gray-800 overflow-hidden bg-gray-50">
              <iframe
                :src="base_url + '?token=' + jwt"
                class="w-full"
                style="height: 90vh"
                referrerpolicy="origin"
                allow="camera"
                v-if="jwt"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");

const alertBox = () =>
  import(/* webpackChunkName: "alertBox" */ "../../Components/alertBox.vue");

export default {
  components: { layout, alertBox },
  data() {
    return {
      jwt: this.$page.props.jwt,
      base_url: this.$page.props.base_url,
    };
  },
  methods: {},
};
</script>